import React, { useContext, useEffect, useState } from 'react';
import { Card } from 'antd';

import RemoteAccessDashboardContext from '@totem/components/services/remoteAccess/v2/summary/remoteAccessDashboardContext';
import { isPersonalEmailDomain } from '@totem/components/services/remoteAccess/v2/summary/utilities';
import { statisticsStyles } from '@totem/components/ui_components/widgets/statistic/IBStatistic';
import { isNull } from '@totem/utilities/common';
import { sortNumberDescending } from '@totem/utilities/tableUtilities';

const RiskAssessment = () => {
  const { organizationSummaryData } = useContext(RemoteAccessDashboardContext);
  const [issues, setIssues] = useState<string[]>([]);

  useEffect(() => {
    if (isNull(organizationSummaryData)) {
      return;
    }

    const tmpIssues: string[] = [];

    // Greatest Risk
    if (organizationSummaryData.length > 1) {
      const sortedRisk = organizationSummaryData.sort((compA, compB) =>
        sortNumberDescending(compA.totalRisk, compB.totalRisk),
      );
      if (sortedRisk[0].totalRisk > sortedRisk[1].totalRisk) {
        tmpIssues.push(
          `Organization ${sortedRisk[0].vendor} represents the greatest risk to security`,
        );
      }
    }

    // Personal Accounts
    const personalAccounts = organizationSummaryData.filter((chk) =>
      isPersonalEmailDomain(chk.vendor),
    );
    if (personalAccounts.length > 1) {
      const totalPersonalAccounts = personalAccounts.reduce(
        (accumulator, currentValue) => {
          return accumulator + currentValue.totalUsers;
        },
        0,
      );

      tmpIssues.push(
        `There are ${totalPersonalAccounts} accounts/users who appear to be using personal accounts`,
      );
    }

    // Average Session Duration
    const averageSessionDuration = organizationSummaryData.filter(
      (chk) => chk.averageSessionDuration / 60 > 8,
    );
    if (averageSessionDuration.length > 0) {
      tmpIssues.push(
        `There are ${averageSessionDuration.length} organizations that appear to have long average session durations (over 8 hours)`,
      );
    }

    setIssues(tmpIssues);
  }, [organizationSummaryData]);

  return (
    <Card
      title={'Risk Assessment'}
      style={{ flex: 1 }}
      styles={{
        header: statisticsStyles.info,
        body: { ...statisticsStyles.subTitle },
        root: { ...statisticsStyles.info },
      }}
    >
      <ul>
        {issues.map((item) => {
          return (
            <li
              key={item}
              style={{ ...statisticsStyles.subTitle, ...statisticsStyles.info }}
            >
              {item}
            </li>
          );
        })}
      </ul>
    </Card>
  );
};

export default RiskAssessment;
